import { useState, useEffect } from "react";
import CustomModal from "../../../components/CustomComponents/modal/customModal";
import FormInput from "../../../components/CustomComponents/Input/formInput";
import showErrorToast from "../../../components/CustomComponents/toast/toast";

function CustomerGroupModel({
  isModalOpen,
  setIsModalOpen,
  onGroupSubmit,
  compID,
  groupToEdit = null,
}) {
  const [groupData, setGroupData] = useState({
    name: "",
    description: "",
  });

  useEffect(() => {
    if (groupToEdit) {
      setGroupData({
        id: groupToEdit.id,
        name: groupToEdit.name,
        description: groupToEdit.description,
      });
    }
  }, [groupToEdit]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setGroupData({
      name: "",
      description: "",
    });
  };

  const handleSubmit = () => {
    try {
      if (!groupData.name || groupData.name.toString().length === 0) {
        showErrorToast("Please Provide Valid Group Name");
        return;
      }

      const submitData = {
        ID: groupToEdit ? groupToEdit.id : 0,
        name: groupData.name,
        description: groupData.description,
        compID: compID,
        updateDateTime: new Date().toISOString(),
      };
      onGroupSubmit(submitData, !!groupToEdit);
      setIsModalOpen(false);
      setGroupData({
        name: "",
        description: "",
      });
    } catch (err) {
      showErrorToast("Something Went Wrong.");
    }
  }

  return (
    <CustomModal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      onSubmit={handleSubmit}
      title={groupToEdit ? "Update Customer Group" : "Add Customer Group"}
      showButton={true}
      isCentered={true}
      submitButtonText={groupToEdit ? "Update" : "Add"}
    >
      <div className="row g-3 mb-4">
        <div className="col-md-12">
          <FormInput
            label="Group Name"
            placeHolder="Enter Group Name"
            type="text"
            value={groupData.name}
            onchange={(e) =>
              setGroupData({
                ...groupData,
                name: e.target.value,
              })
            }
            required
          />
        </div>
        <div className="col-md-12">
          <div className="form-group">
            <h5 className="form-label fw-medium text-dark mb-2">
              Description
            </h5>
            <textarea
              className="form-control"
              placeholder="Enter Description"
              value={groupData.description}
              onChange={(e) =>
                setGroupData({
                  ...groupData,
                  description: e.target.value,
                })
              }
              rows={4}
              style={{
                resize: 'vertical',
                minHeight: '100px',
                borderRadius: '6px',
                border: '1px solid #ced4da',
                padding: '12px 16px',
                fontSize: '14px',
                lineHeight: '1.5',
                transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                fontFamily: 'inherit'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#86b7fe';
                e.target.style.boxShadow = '0 0 0 0.25rem rgba(13, 110, 253, 0.25)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#ced4da';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>
        </div>
      </div>
    </CustomModal>
  );
}

export default CustomerGroupModel;